<template>
  <div
    ref="message"
    :class="['message', customClass]"
  >
    <font-awesome-icon
      v-if="showDecoration"
      :icon="$v7[iconStyle][iconName]"
      :class="['decorative', iconClass]"
    />
    <h4 class="title">{{ messageTitle }}</h4>
    <slot />
  </div>
</template>
<script>
  export default {
    name: 'Setup',

    props: {
      customClass: {
        type: String,
        default: ''
      },

      messageTitle: {
        type: String,
        default: 'Before You Get Started'
      },

      iconClass: {
        type: String,
        default: ''
      },

      iconStyle: {
        type: String,
        default: 'solid'
      },

      iconName: {
        type: String,
        default: 'faCircleInfo'
      },

      replace: {
        type: Object,
        default() {
          return {}
        }
      },

      showDecoration: {
        type: Boolean,
        default: false
      }
    },

    mounted() {
      this.doReplacements()

      if (this.$permits.has('accessToPro')) {
        const elements = Array.from(document.getElementsByClassName('hide-for-pro'))
        elements.forEach(function (element) {
          element.style.display = 'none'
        })
      }
    },

    methods: {
      doReplacements() {
        const replaceKeys = Object.keys(this.replace)
        const message = this.$refs.message

        const r = (node) => {
          ;[...node.childNodes].forEach((child) => {
            if (child.nodeType === Node.TEXT_NODE) {
              replaceKeys.forEach((k) => {
                child.nodeValue = child.nodeValue.replace(k, this.replace[k])
              })
            }
            r(child)
          })
        }

        r(message)
      }
    }
  }
</script>
